import React from 'react'
import numbro from 'numbro';

//OpenLayers
import OlMap from "ol/Map";
import OlView from "ol/View";
import OlFormatGeoJSON from 'ol/format/GeoJSON';
import OlSourceVector from "ol/source/Vector";
import OlLayerVector from "ol/layer/Vector";

import OlSourceTileWMS from "ol/source/TileWMS";
import OlLayerTile from "ol/layer/Tile";

import OlStyle from 'ol/style/Style';
import OlStroke from 'ol/style/Stroke';
import OlFill from 'ol/style/Fill';

import OlSelect from 'ol/interaction/Select';
import OlDragPan from 'ol/interaction/DragPan';
import OlKeyboardPan from 'ol/interaction/KeyboardPan';
import { pointerMove as OlPointerMove } from 'ol/events/condition';

import { defaults as OlInteractionDefaults } from 'ol/interaction';
import { defaults as OlControlDefaults } from 'ol/control';

import { register as OlRegister } from 'ol/proj/proj4'
import { get as OlGetProjection } from 'ol/proj'

import proj4 from 'proj4';

import { Context } from "Context.jsx";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import mapStyle from "assets/jss/prehnit/components/mapStyle.jsx";

import { withNamespaces } from "react-i18next";

import { geoserverService } from "services/geoserver";

const url = process.env.REACT_APP_GeoServer_WFS_Url;


class MapSimple extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);

    this.state = {
      map: undefined,
      viewCenter: [500000, 4900000],
      zoom: this.props.initialZoom,
      height: 0,
      width: 0,

      pointerLeft: 0,
      pointerTop: 0,

      regionId: undefined,
      regionTitle: undefined,
      regionArea: undefined,
      regionCoveragePerc: undefined,
      regionDesc: undefined,

      regionOne: this.props.regionOne,
      regionTwo: this.props.regionTwo,

      features: undefined
    }

    this.highlightedFeatures = [];
    this.selectStylePrimary = new OlStyle({
      stroke: new OlStroke({
        color: 'rgba(67,134,0,1)',
        width: 1
      }),
      fill: new OlFill({
        color: 'rgba(127,193,66,1)'
      })
    });
    this.selectStyleSecondary = new OlStyle({
      stroke: new OlStroke({
        color: 'rgba(251,140,0,1)',
        width: 1
      }),
      fill: new OlFill({
        color: 'rgba(255,167,38,1)'
      })
    });

    this._clearToolTip = this._clearToolTip.bind(this);

    this.handleClick = this.handleClick.bind(this);
    this.handleHover = this.handleHover.bind(this);
    this.handlePointerMove = this.handlePointerMove.bind(this);
    this.handleLeave = this.handleLeave.bind(this);
    this.toggleMapPan = this.toggleMapPan.bind(this);

    proj4.defs("EPSG:3765", "+proj=tmerc +lat_0=0 +lon_0=16.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs");
    OlRegister(proj4);
    this.htrs96 = OlGetProjection('EPSG:3765')

    geoserverService.WFS.getFeatures(this.props.dataLayer)
      .then(data => {
        if (data) {
          data = JSON.parse(data);
        } else {
          console.warn('MapSimple: No data received');
        }

        this.features = (new OlFormatGeoJSON()).readFeatures(data, { featureProjection: this.htrs96 })

        this.features.forEach(function (f) {
          let id = f.get('id', this.props.data);
          let filtered_data = this.props.data.filter(x => x.region_code == id);
          if (filtered_data && filtered_data.length > 0) {
            let d = filtered_data[0];
            f.set('region_area_ha', d.region_area_ha);
            f.set('region_perc', d.region_perc);
            f.set('region_title', d.region_title);
            f.set('region_title_trans_token', d.region_title_trans_token);
            f.set('code_3_count', d.code_3_count);
          }

          if (id == this.props.regionOne) {
            f.setStyle(this.selectStylePrimary);
          } else if (id == this.props.regionTwo) {
            f.setStyle(this.selectStyleSecondary)
          }
        }.bind(this));

        this.regionsLayer = new OlLayerVector({
          source: new OlSourceVector({
            features: this.features
          }),
          updateWhileAnimating: true
        });
        this.map.addLayer(this.regionsLayer);

        if (this._isMounted) {
          this.setState({
            features: this.features
          })
        }
      })
  }

  _clearToolTip() {
    if (this._isMounted) {
      this.setState({
        regionId: null,
        regionTitle: null,
        regionArea: null,
        regionCoveragePerc: null,
        regionDesc: null
      });
    }
  }

  handlePointerMove(event) {
    this.positionToolTip(event.pixel);
  }

  positionToolTip(interact_location) {
    if (this._isMounted) {
      this.setState({
        pointerLeft: interact_location[0] - 75,
        pointerTop: interact_location[1] + 120
      });
    }
  }

  handleHover(event) {
    const { t } = this.props;
    var selected = event.selected;

    if (selected.length > 0) {
      let feat = selected[0];

      let title = feat.get('region_title');
      let token = feat.get('region_title_trans_token');
      if (token && token.length > 0) {
        title = t(token);
      }
      let perc = feat.get('region_perc');
      let percDisp = numbro(perc * 100).divide(100).format() + "%";

      let pov = feat.get('region_area_ha');
      if (this._isMounted) {
        this.setState({
          regionId: feat.get('id'),
          regionTitle: title,
          regionArea: pov,
          regionCoveragePerc: percDisp,
          regionDesc: feat.get('code_3_count')
        });
      }
    } else {
      this._clearToolTip();
    }
  }

  handleClick(evt) {
    let featureCount = 0;

    let newRegionOne = this.props.regionOne;
    let newRegionTwo = this.props.regionTwo;

    this.map.forEachFeatureAtPixel(evt.pixel, function (feature, layer) {
      featureCount += 1;
      if (featureCount > 1) { //we process only the first feature
        return;
      }
      let id = feature.get('id');
      if (!this.props.regionOne) { //set first selected layer
        feature.setStyle(this.selectStylePrimary);
        newRegionOne = id;
      }
      else if (!this.props.regionTwo && this.props.regionOne != id) { //set second selected layer
        feature.setStyle(this.selectStyleSecondary);
        newRegionTwo = id;
      }
      else if (this.props.regionOne == id) { //deselect first
        feature.setStyle(null);
        let id_ch = this.props.regionTwo;
        if (id_ch) {
          this.regionsLayer.getSource().getFeatures().forEach(function (feat) {
            let id = feat.get('id');
            if (id == id_ch) {
              feat.setStyle(this.selectStylePrimary);
            }
          }.bind(this));
        }
        newRegionOne = newRegionTwo;
        newRegionTwo = null;

      } else if (this.props.regionTwo == id) { //deselect second
        feature.setStyle(null);
        newRegionTwo = null;
      } else { //new feature is selected
        feature.setStyle(this.selectStyleSecondary)
        let id_del = this.props.regionOne;
        let id_ch = this.props.regionTwo;
        this.regionsLayer.getSource().getFeatures().forEach(function (feat) {
          let id = feat.get('id');
          if (id == id_del) {
            feat.setStyle(null);
          } else if (id == id_ch) {
            feat.setStyle(this.selectStylePrimary);
          }
        }.bind(this));
        newRegionOne = newRegionTwo;
        newRegionTwo = id;
      }

    }.bind(this));

    if (featureCount > 0 && this.props.onSelect) {
      this.props.onSelect(newRegionOne, newRegionTwo);
    }

  }

  handleLeave(event) {
    this._clearToolTip();
  }

  toggleMapPan(allowPan) {
    let interactions = this.map.getInteractions();

    interactions.getArray().forEach(function (interaction) {
      if (interaction instanceof OlDragPan
        || interaction instanceof OlKeyboardPan) {
        interaction.setActive(allowPan);
      }
    });

  }


  componentDidMount() {
    this._isMounted = true;
    // console.log('MapSimple: componentDidMount');

    this.view = new OlView({
      center: this.state.viewCenter,
      zoom: this.state.zoom,
      extent: [270000, 4710000, 720000, 5140000],
      minZoom: this.props.minZoom,
      maxZoom: this.props.maxZoom,
      projection: 'EPSG:3765'
    });

    if (this.props.allowPan) {
      this.view.on('change:resolution', function (e) {
        let currentZoom = this.view.getZoom();

        //console.log(this.props.minZoom, currentZoom);

        if (Number.isInteger(currentZoom)) {
          let allowPan = currentZoom !== this.props.minZoom;

          this.toggleMapPan(allowPan);

          if (currentZoom === this.props.minZoom) {
            let extent = this.regionsLayer.getSource().getExtent();
            this.view.fit(extent);
          }
        }

      }.bind(this));
    }

    this.hover = new OlSelect({
      condition: OlPointerMove
    });
    this.hover.on('select', this.handleHover);

    // create map object
    this.map = new OlMap({
      interactions: OlInteractionDefaults({
        doubleClickZoom: false,
        dragAndDrop: false,
        dragPan: this.props.allowPan,
        keyboardPan: this.props.allowPan,
        keyboardZoom: true,
        mouseWheelZoom: true,
        pointer: true,
        select: this.select,
        altShiftDragRotate: false,
        pinchRotate: false
      }),
      controls: OlControlDefaults({
        attribution: false,
        zoom: false,
      }),
      target: null,
      view: this.view
    });

    this.map.addInteraction(this.hover);

    this.map.on('pointermove', this.handlePointerMove);

    this.map.on("click", this.handleClick);

    //console.log('MapSimple: setTarget refs mapContainer', this.refs.mapContainer);
    this.map.setTarget(this.refs.mapContainer);

    this.toggleMapPan(false); //initial

    // Background Layer
    if (this.props.backgroundLayer) {
      this.map.addLayer(new OlLayerTile({
        source: new OlSourceTileWMS({
          params: {
            'LAYERS': this.props.backgroundLayer,
            'FORMAT': 'image/png'
          },
          url: url,
          crossOrigin: 'anonymous'
        }),
        style: new OlStyle({
          stroke: new OlStroke({
            color: '#C0C0C0',
            width: 1
          }),
          fill: new OlFill({
            color: 'rgba(0,0,0,1)'
          })
        })
      }));
    }

    //save map and layer references to local state
    if (this.refs.mapContainer) {
      if (this._isMounted) {
        this.setState({
          map: this.map,
          height: this.refs.mapContainer.clientHeight,
          width: this.refs.mapContainer.clientWidth
        })
      }
    } else {
      if (this._isMounted) {
        this.setState({
          map: this.map
        });
      }
    }

  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    const { t, classes } = this.props;

    if (this.features) {
      this.features.forEach(function (f) {
        let id = f.get('id', this.props.data);

        if (id == this.props.regionOne) {
          f.setStyle(this.selectStylePrimary);
        } else if (id == this.props.regionTwo) {
          f.setStyle(this.selectStyleSecondary)
        } else {
          f.setStyle(null);
        }
      }.bind(this));
    }



    // console.log('MapSimple: render');

    return (
      <div>
        <div ref="mapContainer" id="map" className={classes.simpleMap} onMouseLeave={this.handleLeave} >

          {this.state.regionId ?
            <div id="tooltip" className={classes.simpleMapToolTip} style={{ display: "block", left: this.state.pointerLeft, top: this.state.pointerTop }}>
              {this.state.regionTitle}<br />
              <Context.Consumer>
                {ctx =>
                  <div>{t("map:area")}: {numbro(ctx.unit.transform(this.state.regionArea) * 100).divide(100).format()} {ctx.unit.short} ({this.state.regionCoveragePerc})<br /></div>
                }
              </Context.Consumer>

              {t("map:number-of-classes")}: {this.state.regionDesc}<br />
            </div>
            : null}

        </div>
      </div>
    );
  }
}

export default withNamespaces()(withStyles(mapStyle)(MapSimple));
